export default class ClassificationDataService {
    // Services
	$http = null;
	$q = null;

	constructor($http, $q) {
		this.$http = $http;
		this.$q = $q;
	}

	update(dbId, data) {
		const def = this.$q.defer();

		const promise = this.$http.post(`/api.php/dbs/${dbId}/classifier_info`, data);

		promise.then(
			(response) => {
				def.resolve(response.data);
			},
			(response) => {
				def.reject(response?.data);
			}
		);

		return def.promise;
	}

	getByDbId(dbId) {
		const def = this.$q.defer();

		const promise = this.$http.get(`/api.php/dbs/${dbId}/classifier_info`);

		promise.then(
			(response) => {
				def.resolve(response.data);
			},
			(response) => {
				def.reject(response.data);
			}
		);

		return def.promise;
	}
    
    clearCache(dbId) {
		const def = this.$q.defer();

		const promise = this.$http.post(`/api.php/dbs/${dbId}/classifier_info/clear_cache`);

		promise.then(
			(response) => {
				def.resolve(response.data);
			},
			(response) => {
				def.reject(response.data);
			}
		);

		return def.promise;
    }

	runClassification(dbId, params) {
		const def = this.$q.defer();

		const promise = this.$http.post(`/api.php/dbs/${dbId}/run_classify`, params);

		promise.then(
			(response) => {
				def.resolve(response.data);
			},
			(response) => {
				def.reject(response.data);
			}
		);

		return def.promise;
	}
}

ClassificationDataService.$inject = ['$http', '$q'];